<app-header (requestConsentmentTerm)="showConsentmentTerm()"></app-header>
<ng-sidebar-container  [ngClass]="{'nochat': !menu?.hasChatPod || !util?.hasUserChat || util?.configuration?.disableChatBar, 'minimized': menu?.chatMinimized}" >
  <ng-sidebar #sidebar [mode]="menu.mode" [dock]="menu.dock" [dockedSize]="dockedSize"  (mouseover)="menu.mouseover()"  (mouseout)="menu.mouseout()"
    (onModeChange)="menu.modeChange($event)" [(opened)]="menu.opened">
    <perfect-scrollbar [config]="util?.scrollconfig" class="scroll-container-menu">
      @if (util.configuration) {
        <app-sidebar></app-sidebar>
      }
    </perfect-scrollbar>
  </ng-sidebar>
  <div class="page-container fr-view" #sidebarContent ng-sidebar-content>
    <router-outlet></router-outlet>
  </div>
</ng-sidebar-container>
@defer (on idle) {
  <app-quickview [visibleChat]="(menu?.hasChatPod && util?.hasUserChat && !util?.configuration?.disableChatBar)" class="hidden-lg-down"></app-quickview>
}
@defer (on idle) {
  <app-voip-call #voipCall></app-voip-call>
}
@defer (on idle) {
  <app-conference-pip></app-conference-pip>
}
@defer (on idle) {
  <app-consentment-term #consentmentTerm (outputEvent)="loadAllowNotification()"></app-consentment-term>
  <app-new-hires-modal #newHire></app-new-hires-modal>
  <app-allow-notification #allowNotification></app-allow-notification>
  <app-signature-screen #signature></app-signature-screen>
}
@defer (on idle) {
  @for (chat of ch?.openedChats; track chat; let i = $index) {
    <app-chat-window [chatId]="chat?.id" class="chat-window" [ngClass]="{'chat-first-window': i===0, 'chat-second-window': i===1, 'chat-third-window': i===2, 'chat-fourth-window': i===3}"></app-chat-window>
  }
}
@defer (on idle) {
  <app-chatbot-window [ngClass]="{'grecaptcha-badge': router?.url && router?.url?.indexOf('/message') !== -1}"></app-chatbot-window>
}
@if (configuration?.srcHtml) {
  <div class="fr-view" [innerHTML]="configuration?.srcHtml | safeUrl"></div>
}